import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="108"
    viewBox="0 0 108 108"
    width="108"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <filter
      id="a"
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
      height="108"
      width="108"
      x="0"
      y="0"
    >
      <feFlood floodOpacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="5" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
    </filter>
    <g filter="url(#a)">
      <rect height="88" rx="16" width="88" x="10" y="8" />
      <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="m65.9796 26.2585h5.3954c1.4918 0 2.9226.6526 3.9775 1.8141s1.6475 2.7368 1.6475 4.3794v43.3545c0 1.6426-.5926 3.2179-1.6475 4.3794s-2.4857 1.814-3.9775 1.814h-33.75c-1.4918 0-2.9226-.6525-3.9775-1.814s-1.6475-2.7368-1.6475-4.3794v-43.3545c0-1.6426.5926-3.2179 1.6475-4.3794s2.4857-1.8141 3.9775-1.8141h4.477" />
        <path d="m62.6107 21h-17.2675c-1.5894 0-2.8779 1.1772-2.8779 2.6293v5.2586c0 1.4522 1.2885 2.6293 2.8779 2.6293h17.2675c1.5894 0 2.8779-1.1771 2.8779-2.6293v-5.2586c0-1.4521-1.2885-2.6293-2.8779-2.6293z" />
        <path d="m65.4883 47.2931-12.8695 15.05c-.7983.9336-2.2417.9336-3.04 0l-5.0207-5.8713" />
      </g>
    </g>
  </svg>
);
